export enum CONTRACTOR_TYPE_TIN_ENUM {
  PL = 1,
  EU = 2,
  Other = 3,
}
